
import React, { useContext } from "react";
import Cam from "../img/cam.png";
import Add from "../img/add.png";
import More from "../img/more.png";
import Messages from "./Messages";
import Input from "./Input";


import { ChatContext } from "../context/ChatContext";
const Chat = (ws) => {
  const { data } = useContext(ChatContext);
  // const xyz = useLocation();
  return (
    <div className="chat">
      <div className="chatInfo">
        <span>{data.user?.displayName}</span>
        <div className="chatIcons">
          <img src={Cam} alt="" />
          <img src={Add} alt="" />
          <img src={More} alt="" />
        </div>
      </div>
      <Messages ws = {ws.ws} />
      <Input ws = {ws.ws}/>
    </div>
  );
};

export default Chat;